'use client';

import useVelocityStore from '../stores/VelocityStore/useVelocityStore';

const useVelocityClientIsReady = () => {
	const velocityClientIsReady = useVelocityStore((s) => {
		return (
			s.velocityClient.client &&
			s.velocityClient.client.isSubscribed &&
			s.velocityClient.isSubscribed
		);
	});

	return velocityClientIsReady ?? false;
};

export default useVelocityClientIsReady;
